import * as React from 'react';

export default function Spinner({ title, subtitle }: { title?: string, subtitle?: string }) {
	return <div className='splash-title'>
		{title ? <h1>{title}</h1> : null}
		{subtitle ? <p>{subtitle}</p> : null}

		<div className='spinner' style={{ marginTop: '5em' }}>
			<div className='rect1' style={{ marginLeft: '0.2em' }}></div>
			<div className='rect2' style={{ marginLeft: '0.2em' }}></div>
			<div className='rect3' style={{ marginLeft: '0.2em' }}></div>
			<div className='rect4' style={{ marginLeft: '0.2em' }}></div>
			<div className='rect5' style={{ marginLeft: '0.2em' }}></div>
		</div>
	</div>;
}
